export type Unit =
  | 'second'
  | 'minute'
  | 'hour'
  | 'day'
  | 'week'
  | 'month'
  | 'quarter'
  | 'year';

const MS_PER_SECOND = 1e3;
const SECS_PER_MIN = 60;
const SECS_PER_HOUR = SECS_PER_MIN * 60;
const SECS_PER_DAY = SECS_PER_HOUR * 24;
const SECS_PER_WEEK = SECS_PER_DAY * 7;
const SECS_PER_MONTH = SECS_PER_DAY * 30;
const SECS_PER_YEAR = SECS_PER_DAY * 365;

const THRESHOLDS = {
  second: 60, // seconds to minute
  minute: 60, // minutes to hour
  hour: 24, // hour to day
  day: 7, // day to week
  week: 4, // week to month
  month: 12, // month to year
};

export default function selectUnit(
  from: Date | number,
  to: Date | number,
): {value: number; unit: Unit} {
  const secs = (+from - +to) / MS_PER_SECOND;

  if (Math.abs(secs) < THRESHOLDS.second) {
    return {
      value: Math.round(secs),
      unit: 'second',
    };
  }

  const mins = secs / SECS_PER_MIN;

  if (Math.abs(mins) < THRESHOLDS.minute) {
    return {
      value: Math.round(mins),
      unit: 'minute',
    };
  }

  const hours = secs / SECS_PER_HOUR;

  if (Math.abs(hours) < THRESHOLDS.hour) {
    return {
      value: Math.round(hours),
      unit: 'hour',
    };
  }

  const days = secs / SECS_PER_DAY;

  if (Math.abs(days) < THRESHOLDS.day) {
    return {
      value: Math.round(days),
      unit: 'day',
    };
  }

  const weeks = secs / SECS_PER_WEEK;

  if (Math.abs(weeks) < THRESHOLDS.week) {
    return {
      value: Math.round(weeks),
      unit: 'week',
    };
  }

  const months = secs / SECS_PER_MONTH;

  if (Math.abs(months) < THRESHOLDS.month) {
    return {
      value: Math.round(months),
      unit: 'month',
    };
  }

  const years = secs / SECS_PER_YEAR;

  return {
    value: Math.round(years),
    unit: 'year',
  };
}
